import { isSuccessfulStatusCode } from '../../../helpers/api-ts/request'
import { authorizedFetch } from '../../helpers/authorizedFetch'
import trans from '../../helpers/trans'
import { generateApiV3Url } from '../../helpers/url'
import { FetchResult, FetchResultType } from '../FetchResult'
import { ShiftPlanning } from '../ShiftPlanning/ShiftPlanning'
import {
    BaseScheduleShiftPlanningDetailResource,
    CreateBaseScheduleShiftPlanningRequest,
    PatchBaseScheduleShiftPlanningRequest,
} from './BaseScheduleShiftPlanning'
import { transformBaseScheduleShiftPlanning } from './BaseScheduleShiftPlanningTransformers'

export const getBaseScheduleShiftPlanningApiCall = async (
    planningId: string,
): Promise<FetchResult<ShiftPlanning, string>> => {
    try {
        const url = generateApiV3Url({ endpoint: `/base-schedule-shift-plannings/${planningId}` })

        const response = await authorizedFetch(url)

        if (! isSuccessfulStatusCode(response.status)) {
            return {
                status: response.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            }
        }

        const data: BaseScheduleShiftPlanningDetailResource = await response.json()

        return {
            status: response.status,
            type: FetchResultType.Success,
            data: transformBaseScheduleShiftPlanning(data),
        }
    } catch (error) {
        console.error('[getBaseScheduleShiftPlanningApiCall]', error)

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        }
    }
}

export const postBaseScheduleShiftPlanningApiCall = async (
    request: CreateBaseScheduleShiftPlanningRequest,
): Promise<FetchResult<ShiftPlanning, string>> => {
    try {
        const url = generateApiV3Url({ endpoint: '/base-schedule-shift-plannings' })

        const response = await authorizedFetch(url, {
            method: 'POST',
            body: JSON.stringify(request),
        })

        if (! isSuccessfulStatusCode(response.status)) {
            return {
                status: response.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            }
        }

        const data: BaseScheduleShiftPlanningDetailResource = await response.json()

        return {
            status: response.status,
            type: FetchResultType.Success,
            data: transformBaseScheduleShiftPlanning(data),
        }
    } catch (error) {
        console.error('[postBaseScheduleShiftPlanningApiCall]', error)

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        }
    }
}

export const patchBaseScheduleShiftPlanningApiCall = async (
    planningId: string,
    request: PatchBaseScheduleShiftPlanningRequest,
): Promise<FetchResult<ShiftPlanning, string>> => {
    try {
        const url = generateApiV3Url({ endpoint: `/base-schedule-shift-plannings/${planningId}` })

        const response = await authorizedFetch(url, {
            method: 'PATCH',
            body: JSON.stringify(request),
        })

        if (! isSuccessfulStatusCode(response.status)) {
            return {
                status: response.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            }
        }

        const data: BaseScheduleShiftPlanningDetailResource = await response.json()

        return {
            status: response.status,
            type: FetchResultType.Success,
            data: transformBaseScheduleShiftPlanning(data),
        }
    } catch (error) {
        console.error('[patchBaseScheduleShiftPlanningApiCall]', error)

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        }
    }
}

export const deleteBaseScheduleShiftPlanningApiCall = async (
    planningId: string,
): Promise<FetchResult<void, string>> => {
    try {
        const url = generateApiV3Url({ endpoint: `/base-schedule-shift-plannings/${planningId}` })

        const response = await authorizedFetch(url, { method: 'DELETE' })

        if (! isSuccessfulStatusCode(response.status)) {
            return {
                status: response.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            }
        }

        return {
            status: response.status,
            type: FetchResultType.Success,
            data: undefined,
        }
    } catch (error) {
        console.error('[deleteBaseScheduleShiftPlanningApiCall]', error)

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        }
    }
}
